
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lLYUy", function(module, exports) {
$parcel$export(module.exports, "EditorForYouSpotlight", () => (parcelRequire("166II")).EditorForYouSpotlight);

var $166II = parcelRequire("166II");


});


//# sourceMappingURL=EditorForYouSpotlight.ecf98e2a.js.map
